<app-autocomplete-select
  placeholder="{{'search.employee' | translate}}"
  [options]="options"
  [(ngModel)]="value"
  style="width: 100%">
</app-autocomplete-select>
